import styled from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import { FlexBox, Stack } from '@ardoq/layout';
import { PercentageWidgetProps } from './types';
import { NoDataDoqy } from '../atoms/NoDataDoqy';
import { TextFit } from '../atoms/TextFit';

const PercentageLabelContainer = styled(Stack)`
  position: relative;
  width: 100%;
`;

const PercentageNumber = styled.div`
  width: 100%;
  font-weight: 600;
  line-height: 1.4;
  margin: -0.2em 0;
  color: ${colors.textDefault};
  white-space: nowrap;
`;

const Context = styled.div`
  position: absolute;
  top: calc(100% + 16px);
  font-size: 12px;
  color: ${colors.textSubtle};
  line-height: 16px;
`;

const PercentageWidget = (widgetProps: PercentageWidgetProps) => {
  if (widgetProps.hasZeroResults) {
    return (
      <NoDataDoqy
        dashboardMode={widgetProps.dashboardMode}
        i18nLocale={widgetProps.i18nLocale}
      />
    );
  }

  const { formattedPercentage, formattedNumerator, formattedDenominator } =
    widgetProps;
  return (
    <FlexBox
      padding="medium"
      height="full"
      width="full"
      align="center"
      justify="center"
    >
      <PercentageLabelContainer gap="none" align="center" justify="center">
        <PercentageNumber>
          <TextFit value={formattedPercentage} />
        </PercentageNumber>
        <Context>
          {formattedNumerator} out of {formattedDenominator}
        </Context>
      </PercentageLabelContainer>
    </FlexBox>
  );
};

export { PercentageWidget };
